const base =
  "inline-flex items-center gap-1.5 px-3 py-2 text-xs font-semibold text-white rounded-xl border shadow-sm hover:shadow-md active:translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none cursor-pointer transition";

export const leadStatusActionClass = {
  converted: `${base} bg-emerald-600 hover:bg-emerald-700 border-emerald-500`,
  lost: `${base} bg-red-600 hover:bg-red-700 border-red-500`,
  rejected: `${base} bg-amber-600 hover:bg-amber-700 border-amber-500`,
};
